import type {
  IMenuCustomization,
  IMenuCustomizationGroup,
  IMenuProduct,
} from './menuPage.model';

export function validateProductsOutOfStock(
  products: IMenuProduct[],
): IMenuProduct[] {
  return Array.from(
    new Map(products.filter(p => !p.isOn).map(p => [p.id, p])).values(),
  );
}

export function validateCustomizationsOutOfStock(
  customsGroups: IMenuCustomizationGroup[],
): IMenuCustomization[] {
  return customsGroups.reduce<IMenuCustomization[]>(
    (acc, cg) => [
      ...acc,
      ...cg.items.filter(
        item => !item.isOn && !acc.find(custom => custom.id === item.id),
      ),
    ],
    [],
  );
}
